import React from 'react'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import {Link} from "react-router-dom"




const Navbarmenu = () => {
  return (
    <div id='navbar'>
      <div className="container">
         <Navbar expand="lg">
      <Container fluid>
       
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="menubar"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
             <NavDropdown title="Product Categories" id="navbarScrollingDropdown">
             <NavDropdown.Item className='dropdown-hd'>Categories</NavDropdown.Item>
             <div className="sidemenu">

              <Link to="/video-tape-encoding-services">Videotape Encoding Services</Link>
              <Link to="/computers-&-software">Computers & Softwares</Link>
              <Link to="/cameras">Cameras</Link>
              <Link to="/camera-tripod-&-lenses">Camera Tripod, Lenses</Link>
              <Link to="/Digibeta">Digibeta</Link>
              <Link to="/Betamax">Betamax</Link>
              <Link to="/TBC">TBC</Link>
              <Link to="/CamerasXDCAM">Cameras XDCAM</Link>
              <Link to="/KXDCAM">4K XDCAM</Link>
              <Link to="/KHDRCAMCORDER">4K HDR CAMCORDER</Link>
              <Link to="/Pedestal">Pedestal</Link>
              <Link to="/Monitors">Monitors</Link>
              



              <Link to="/2-inch-quad">2 INCH QUAD</Link>
              <Link to="/dAs">DAs</Link>
              <Link to="/tripod-heads">Tripod heads</Link>
              <Link to="/tripods">Tripods </Link>
              <Link to="/ccd-cameras">3CCD Cameras </Link>
              <Link to="/view-finders">ViewFinders </Link>
              <Link to="/xd-cam">XDCAM </Link>
              <Link to="/dvcammnidv">DVCAMMNIDV </Link>
              <Link to="/beta-cam-sp">BETACAM SP </Link>
              <Link to="/beta-decks">Beta Decks </Link>
              <Link to="/ID1DigitalInstrumentation">ID-1 Digital Instrumentation</Link>
              <Link to="/Remotecontrolpanel">Remote control panel</Link>
              <Link to="/Film">Film</Link>
              <Link to="/FluidHead">Fluid Head </Link>




              <Link to="/lenses">Lenses</Link>
              <Link to="/lights-&-studios">Lights, Studio</Link>
              <Link to="/camcorders">Camcorders</Link>
              <Link to="/motion-pictures-film-transer">Motion Picture Film transfer</Link>
              <Link to="/transmitter">Transmitter</Link>
              <Link to="/audio">Audio</Link>
              <Link to="/color-monitors">Color Monitors</Link>
              <Link to="/switchers">Switchers</Link>
              <Link to="/mii">Mii</Link>
              <Link to="/hd-cam-sr">Hdcam Sr</Link>
              <Link to="/digital-betacam-camcorder">Digital Betacam Camcorder</Link>
              <Link to="/hd-studio-cameras">1080i HD Studio Cameras</Link>
              <Link to="/p2-hdr-hd-camcorder">P2 HDR HD Camcorder </Link>
              <Link to="/hd-cam-camcorders">HDCAM Camcorders </Link>
              </div>

              
              <Link className='dropdown-hd'>Top brands</Link>
              <div className="sidemenu">
              <Link to="/the-broadcast-store">Broadcast Store</Link>
              <Link to="/canon">Canon</Link>
              <Link to="/umatics">Umatics</Link>
              <Link to="/digital-beta-cam">Digital Betacam</Link>
              <Link to="/d1-tapes">D1</Link>
              <Link to="/d2">D2</Link>
              <Link to="/d3">D3</Link>
              <Link to="/D5">D5</Link>
              <Link to="/dv-cam">Dvcam</Link>
              <Link to="/hi8">Hi8</Link>
              <Link to="/svhs">Svhs</Link>
              <Link to="/super-betamax">Super Betamax</Link>
              <Link to="/digital-hi8-deck">Digital Hi8 deck</Link>
              <Link to="/monitor-with-sdi">Monitor with SDI</Link>

              <Link to="/tbc">TBC</Link>
              <Link to="/frame-synchronizer-converter">Frame Synchronizer/Converter</Link>
              <Link to="/professional-video-i-o-with-tb3">Professional Video I/O with TB3</Link>
              <Link to="/ntsc-signal-generator">NTSC Signal Generator</Link>
              <Link to="/vectorscope">Vectorscope</Link>
              <Link to="/waveform-monitors">Waveform Monitors</Link>
              <Link to="/encoder-decoder">Encoder/Decoder</Link>


        
              <Link to="/DVCPRO">DVCPRO HD</Link>
              <Link to="/track-recorder">24 Tracks Recorder </Link>
              <Link to="/hd-cam-editing-recorder">HD CAM Editing recorder </Link>
              <Link to="/inch1">1 Inch</Link>
              <Link to="/tape-playback">TapePlayback</Link>
              <Link to="/tape-cleaners">Tape Cleaners</Link>
              </div>



            
              <Link className='dropdown-hd'>Top Models</Link>
              <Link to="/sony-bvu-950">Sony BVU-950</Link>
              <Link to="/quad-broadcast">2" Quad broadcast Editor and Player</Link>
             
            </NavDropdown>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="#action1">Recent Searches</Link>
            <Link to="#action1">New Product Catalog</Link>
          
          </Nav>
          <div className="btns">
                <Button className="theme-btn">
                  <Link to="/contact"> Contact Us</Link>
                  
                </Button>
                
              </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>


    </div>
  )
}

export default Navbarmenu